import {LANGUAGES} from './languages.js';

export const socialImage = {
    url: 'https://yourlovely.place/public/examples/600x600/4-v2.jpg',
    alt: 'A framed typographic map of Poland, ready to print as a personalised poster',
    width: 600,
    height: 600,
    type: 'image/jpeg',
};

export const socialLocales = Object.fromEntries(LANGUAGES.filter(({socialLocale}) => socialLocale).map(({code, socialLocale}) => [code, socialLocale]));
